// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__3s+9K","step":"style_step__AOSzJ","duration":"style_duration__m4D1X","info":"style_info__+-mLm","time-status":"style_time-status__VHpJ8"};